import {
  BarChart3,
  Building2,
  LayoutDashboard,
  MessageSquare,
  Package,
  Settings,
  ShoppingCart,
  Truck,
  UserCog,
  Users,
  Wallet,
  Warehouse,
  type LucideIcon,
} from 'lucide-react';

const ICONS: Record<string, LucideIcon> = {
  LayoutDashboard,
  ShoppingCart,
  Users,
  Package,
  Truck,
  Warehouse,
  Wallet,
  BarChart3,
  UserCog,
  MessageSquare,
  Settings,
  Building2,
};

/** Resolves the icon name declared in the navigation config to a component. */
export function NavIcon({ name, className }: { name: string; className?: string }) {
  const Icon = ICONS[name] ?? LayoutDashboard;
  return <Icon className={className} aria-hidden />;
}
